import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { useDirtyGuard } from "../../context/DirtyGuard";
import { createBranch, updateBranch } from "../../api/directory";
import { EMPTY_BRANCH, toBranchPayload } from "./branchFields";

// حالة استمارة الفرع: القيم الابتدائية، الحفظ، وحماية التعديلات غير المحفوظة.
export const useBranchForm = (initial, onSaved) => {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({
    ...EMPTY_BRANCH,
    ...(initial || {}),
    payroll: { ...EMPTY_BRANCH.payroll, ...(initial?.payroll || {}) },
    leave: { ...EMPTY_BRANCH.leave, ...(initial?.leave || {}) },
    attendance: { ...EMPTY_BRANCH.attendance, ...(initial?.attendance || {}) },
    contact: { ...EMPTY_BRANCH.contact, ...(initial?.contact || {}) },
    legal: { ...EMPTY_BRANCH.legal, ...(initial?.legal || {}) },
  });

  const persist = useCallback(async () => {
    const body = toBranchPayload(form);
    if (initial?.id) await updateBranch(initial.id, body);
    else await createBranch(body);
    qc.invalidateQueries({ queryKey: ["salary-holds"] });
    toast.success(t("branches.created"));
  }, [form, initial?.id, qc, t]);

  const submit = async (e) => {
    e?.preventDefault?.();
    setBusy(true);
    try {
      await persist();
      onSaved();
    } catch {
      toast.error(t("errors.generic"));
      throw new Error("save_failed");
    } finally {
      setBusy(false);
    }
  };

  const snapshot = useRef(null);
  useEffect(() => {
    snapshot.current = JSON.stringify(form);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial?.id]);

  useDirtyGuard(Boolean(snapshot.current) && JSON.stringify(form) !== snapshot.current, persist);

  return { form, setForm, busy, submit };
};
